/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CityModel,
    CityModelFromJSON,
    CityModelToJSON,
} from '../models';

/**
 * 
 */
export class CityApi extends runtime.BaseAPI {

    /**
     * Captcha ( Guest = guest )
     */
    async cityExactGetRaw(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Array<CityModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/City/exact`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CityModelFromJSON));
    }

    /**
     * Captcha ( Guest = guest )
     */
    async cityExactGet(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Array<CityModel>> {
        const response = await this.cityExactGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Captcha ( Guest = guest )
     */
    async cityGetRaw(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Array<CityModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/City`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CityModelFromJSON));
    }

    /**
     * Captcha ( Guest = guest )
     */
    async cityGet(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Array<CityModel>> {
        const response = await this.cityGetRaw(initOverrides);
        return await response.value();
    }

}
